import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { Toaster } from '@/components/ui/sonner';
import Login from '@/pages/Login';
import MainAdminDashboard from '@/pages/MainAdminDashboard';
import SubAdminDashboard from '@/pages/SubAdminDashboard';
import PublicVerification from '@/pages/PublicVerification';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/verify" element={<PublicVerification />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute allowedRoles={['main_admin']}>
                <MainAdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sub-admin"
            element={
              <ProtectedRoute allowedRoles={['sub_admin']}>
                <SubAdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/verify" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
